import { render, staticRenderFns } from "./AdminProdLocation.vue?vue&type=template&id=2bcbe738&scoped=true&"
import script from "./AdminProdLocation.vue?vue&type=script&lang=js&"
export * from "./AdminProdLocation.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdLocation.vue?vue&type=style&index=0&id=2bcbe738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcbe738",
  null
  
)

export default component.exports